<template>
  <div class="waves">
    <div class="wave wave--back">
      <div class="water">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 32" preserveAspectRatio="none">
          <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"/>
        </svg>
      </div>
      <div class="water">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 32" preserveAspectRatio="none">
          <path d="M350,17.32V32H0V17.32C116.56,65.94,175-39.51,350,17.32Z"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name:"Carga liquido"
}
</script>
